module.exports = __webpack_public_path__ + "static/media/INV-0224- Administrative Penalty Order - Joy Nneji.a0e5376d.pdf";